import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {DcpAuthService} from '../../auth/services/dcp-auth.service';
import {map, take} from 'rxjs/operators';
import {UntilDestroy} from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class AuthGuardWithRedirection {
  constructor(private authService: DcpAuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.authService.isUserLoggedIn().pipe(
      take(1),
      map((loggedIn) => {
        if (!loggedIn) {
          this.router.navigate([route.data.redirectUrl]);
          return false;
        }
        return true;
      })
    );
  }
}
